<template>
  <v-tab-item :data-testid="dataTestId">
    <div :class="['claims-list-header', { 'no-claims-header': claims && claims.length === 0 }]">
      <ParticipantClaimsSortBy
        v-if="claims && claims.length > 0"
        :sortOrder="claimOptions.sortOrder"
        @update:sortOrder="updateOptions({ sortOrder: $event })"
      />
      <v-progress-linear v-if="isLoading" indeterminate color="brandPrimary" class="mb-2" />
    </div>
    <v-data-iterator
      :items="claims"
      :items-per-page="claimOptions.itemsPerPage"
      :page="claimOptions.page"
      :server-items-length="claimOptions.total"
      :hide-default-footer="claimOptions.total === 0"
      :footer-props="{
        'disable-pagination': isLoading,
        'disable-items-per-page': isLoading || claimOptions.total <= 10,
        'items-per-page-options': itemsPerPageOptions,
      }"
      @update:page="updateOptions({ page: $event })"
      @update:items-per-page="updateOptions({ itemsPerPage: $event })"
    >
      <template v-slot:default="{ items }">
        <div class="claims-list">
          <ClaimCardWithDetails v-for="claim in items" :key="claim.id" :claim="claim" />
        </div>
      </template>
      <template v-slot:no-data>
        <Typography variant="body-2">{{ noClaimsMessage }}</Typography>
      </template>
    </v-data-iterator>
  </v-tab-item>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import ClaimCardWithDetails from "../ClaimCardWithDetails.vue";
import ParticipantClaimsSortBy from "./ParticipantClaimsSortBy.vue";

export default {
  name: "ParticipantClaimsTabItem",
  components: {
    Typography,
    ClaimCardWithDetails,
    ParticipantClaimsSortBy,
  },
  props: {
    claims: {
      type: Array,
      default: () => [],
    },
    claimOptions: {
      type: Object,
      default: () => ({
        total: 0,
        page: 1,
        itemsPerPage: 10,
        sortOrder: "desc",
      }),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    noClaimsMessage: {
      type: String,
      default: "There aren't any claims here right now.",
    },
    dataTestId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      itemsPerPageOptions: [10, 25, 50, 100],
    };
  },
  methods: {
    updateOptions(updates) {
      this.$emit("update:claimOptions", {
        ...this.claimOptions,
        ...updates,
      });
    },
  },
};
</script>

<style scoped>
.claims-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.claims-list-header {
  display: flex;
  flex-direction: column;
}

.no-claims-header {
  margin-top: 1.5rem;
}

.no-data-wrapper {
  padding: 2rem;
  text-align: center;
}
</style>
